<div class="analytics-dashboard">
    <!-- Period Selector -->
    <div class="period-bar">
        <div class="period-buttons">
            <button *ngFor="let p of periods"
                    class="period-button"
                    [class.active]="selectedPeriod === p.value"
                    (click)="onPeriodChange(p.value)">
                {{ p.labelKey | translate }}
            </button>
        </div>

        <div class="custom-dates" *ngIf="showCustomDates">
            <label class="date-label">{{ 'user_records.analytics.from' | translate }}</label>
            <input type="date" [(ngModel)]="customFrom" (change)="onCustomDateChange()" class="date-input">
            <label class="date-label">{{ 'user_records.analytics.to' | translate }}</label>
            <input type="date" [(ngModel)]="customTo" (change)="onCustomDateChange()" class="date-input">
        </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'user_records.analytics.loading' | translate }}</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
        <mat-icon>error_outline</mat-icon>
        <p>{{ 'user_records.analytics.error' | translate }}</p>
        <button class="retry-button" (click)="retry()">{{ 'user_records.analytics.retry' | translate }}</button>
    </div>

    <!-- Dashboard Content -->
    <div *ngIf="!loading && !error && snapshot" class="dashboard-content">
        <app-user-kpi-cards [snapshot]="snapshot"></app-user-kpi-cards>

        <!-- Row 1: Card Types + Subscription Codes -->
        <div class="charts-row-2col">
            <app-user-card-type-chart
                [data]="distribution?.cardTypes || []">
            </app-user-card-type-chart>

            <app-user-subscription-code-chart
                [data]="distribution?.subscriptionCodes || []">
            </app-user-subscription-code-chart>
        </div>

        <!-- Row 2: New Users + Card Registrations trends -->
        <div class="charts-row-2col">
            <app-user-new-users-trend
                [data]="trends?.newUsersPerMonth || []">
            </app-user-new-users-trend>

            <app-user-card-registrations-trend
                [data]="trends?.cardRegistrationsPerMonth || []">
            </app-user-card-registrations-trend>
        </div>

        <!-- Row 3: Subscriptions trend (full width) -->
        <div class="charts-row-full">
            <app-user-subscriptions-trend
                [data]="trends?.subscriptionsPerMonth || []">
            </app-user-subscriptions-trend>
        </div>

        <!-- Row 4: Heatmap (full width) -->
        <div class="charts-row-full">
            <app-user-heatmap
                [residents]="geo?.residents || []"
                [cards]="geo?.cards || []">
            </app-user-heatmap>
        </div>
    </div>
</div>
